class RespuestaReadDto {
  public id: number;
  public option: string;
  public value: number;
}

export default RespuestaReadDto;
